import { FC } from 'react';
import LoginBody from '../LoginWithEmailModalBody';
import { CustomDialog } from './LoginWithEmailTipsDialog.styles';
type LoginWithEmailTipsDialogProps = {
  toggleTipsDialog: () => void;
  isTipsDialogVisible: boolean;
};
const LoginWithEmailTipsDialog: FC<LoginWithEmailTipsDialogProps> = ({
  toggleTipsDialog,
  isTipsDialogVisible
}) => {
  return <CustomDialog onClose={toggleTipsDialog} open={isTipsDialogVisible} data-test-id="patient-services-tips-dialog" aria-labelledby="dialog-title" aria-modal="true" data-sentry-element="CustomDialog" data-sentry-component="LoginWithEmailTipsDialog" data-sentry-source-file="LoginWithEmailTipsDialog.tsx">
			<LoginBody toggleDialog={toggleTipsDialog} data-sentry-element="LoginBody" data-sentry-source-file="LoginWithEmailTipsDialog.tsx" />
		</CustomDialog>;
};
export default LoginWithEmailTipsDialog;